module.exports = new __parcel__URL__("ethereum1.6a72ab43.svg").toString();